import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

import { PageWrapper } from 'pages/Workshop/PageWrapper';

import {
  resetTransactionsTasksSearchEffect,
  searchTransactionsTasksEffect,
} from 'store/effects/taskAggregate';

import { useFetchTasks } from './hooks/useFetchTasks';

import styles from './styles.module.scss';
import { RevampedHeader } from '../components';
import classNames from 'classnames';
import { TaskActionButtons } from './components/TaskActionButtons';

import { TaskSelectionFooter } from '../Transactions/components/TaskSelectionFooter';

import { TasksContent } from './components/TasksContent';

import { TasksUpdateModal } from './components/TasksUpdateModal';
import { PageSearchWrapper } from '../components/PageSearchWrapper';

export const Tasks = () => {
  const dispatch = useDispatch();

  const [showSelection, setShowSelection] = useState<boolean>(false);
  const [selectedTaskIds, setSelectedTaskIds] = useState<number[]>([]);
  const [showTaskUpdateModal, setShowTaskUpdateModal] = useState<boolean>(false);

  const [isSearchActive, setSearchActive] = useState(false);

  const { fetchAggregateTasks, isPending, fullAccess, filtersApplied } = useFetchTasks({
    selectedTaskIds,
  });

  useEffect(() => {
    setSelectedTaskIds([]);
  }, [showSelection]);

  const handleSelectTask = (taskId: number | number[], checked: boolean) => {
    let selectedTasks = [...selectedTaskIds];
    const isArray = Array.isArray(taskId);
    if (checked) {
      isArray ? selectedTasks.push(...taskId) : selectedTasks.push(taskId);
    } else {
      if (!isArray) {
        const deselectedTaskIndex = selectedTasks.indexOf(taskId);
        selectedTasks.splice(deselectedTaskIndex, 1);
      } else {
        selectedTasks = selectedTasks.filter((id) => !taskId.includes(id));
      }
    }

    setSelectedTaskIds(selectedTasks);
  };

  const handleContinueTaskUpdates = () => {
    setShowTaskUpdateModal(true);
  };

  return (
    <PageWrapper
      isHideFooter
      isContainer={false}
      pageWrapperContainerClassName={styles.mainPageContent}
    >
      <RevampedHeader
        className={classNames(styles.workshopPageHeader, {
          [styles.activeSearchWorkshopPageHeader]: isSearchActive,
        })}
        title={'Tasks'}
        titleClassName={styles.headerTitle}
        actionButtons={
          <TaskActionButtons
            onSearchClick={() => setSearchActive(true)}
            showSelection={showSelection}
            onShowSelection={setShowSelection}
          />
        }
      />

      <PageSearchWrapper
        isSearchActive={isSearchActive}
        resetAction={resetTransactionsTasksSearchEffect}
        sendAction={searchTransactionsTasksEffect}
        onCloseSearch={() => setSearchActive(false)}
      />

      <TasksContent
        showSelectAll
        showListView={filtersApplied || isSearchActive}
        isPending={isPending}
        showSelection={showSelection}
        isSearchActive={isSearchActive}
        selectedTasks={selectedTaskIds}
        handleSelectTask={handleSelectTask}
        fetchAggregateTasks={fetchAggregateTasks}
      />

      {showSelection && (
        <TaskSelectionFooter
          className={!filtersApplied && !isSearchActive ? styles.tasksTabViewFooter : ''}
          selectedTasks={selectedTaskIds?.length}
          handleContinueTaskUpdates={handleContinueTaskUpdates}
        />
      )}

      <TasksUpdateModal
        isAggregatePage
        fullAccess={fullAccess}
        selectedTaskIds={selectedTaskIds}
        setShowSelection={setShowSelection}
        showTaskUpdateModal={showTaskUpdateModal}
        setShowTaskUpdateModal={setShowTaskUpdateModal}
      />
    </PageWrapper>
  );
};
